export default __webpack_public_path__ + "static/media/ai.fa281314.svg";